import { type FC, type ReactNode, useEffect, useState } from 'react';

import Card from 'react-bootstrap/Card';
import './styles/styles.css';

import { OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';

interface PackageCardProps {
  title?: string;
  description?: string;
  icon?: ReactNode;
  value: string;
}

export const ReservationTypeCard: FC<PackageCardProps> = ({
  title,
  description,
  value,
  icon,
}) => {
  const [maxTitleLength, setMaxTitleLength] = useState(55);
  const { setValue, watch } = useFormContext();
  const selectedValue = watch('reservationType');
  const isSelected = selectedValue === value;

  const handleClick = () => {
    setValue('reservationType', value);
  };

  useEffect(() => {
    const handleResize = () => {
      setMaxTitleLength(window.innerWidth > 900 ? 70 : 55);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Card
      onClick={handleClick}
      className={`reservation-type-card ${isSelected ? 'selected' : ''}`}
      style={{ cursor: 'pointer', position: 'relative' }}
    >
      <div
        style={{
          marginTop: '20px',
          marginRight: '20px',
          position: 'absolute',
          top: 10,
          right: 10,
          width: 16,
          height: 16,
          borderRadius: '50%',
          border: isSelected ? '2px solid #007bff' : '1px solid #c9c9c9',
          backgroundColor: 'transparent',
        }}
      />
      <Card.Body
        style={{
          padding: '0px ',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <div>{icon}</div>
          <Row style={{ marginTop: '30px' }}>
            <span className="type-card-title">{title || ''}</span>
          </Row>

          <Row style={{ marginTop: '5px' }}>
            {description && description.length < maxTitleLength ? (
              <span className="type-card-subtitle">{description}</span>
            ) : (
              <OverlayTrigger overlay={<Tooltip>{description}</Tooltip>}>
                <span className="type-card-subtitle">
                  {description?.substring(0, maxTitleLength)} {' ...'}
                </span>
              </OverlayTrigger>
            )}
          </Row>
        </div>
      </Card.Body>
    </Card>
  );
};
